module.exports = __webpack_public_path__ + "static/414-94fef7f705602392507152743f89fb69.png";